import colors from './utilities/colors.module.scss';
import sizes from './utilities/sizes.module.scss';
import typography from './utilities/typography.module.scss';

const theme = {
  color: colors,
  size: sizes,
  typography: typography,
};

export { theme };
export type Theme = typeof theme;
